function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 1.81976V12.1798C0 12.9698 0.87 13.4498 1.54 13.0198L9.68 7.83976C10.3 7.44976 10.3 6.54976 9.68 6.14976L1.54 0.979764C0.87 0.549764 0 1.02976 0 1.81976Z",
  fill: "#6D0FA7"
});

const SvgPlay = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 14,
  viewBox: "0 0 11 14",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlay, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/play.e9071c65.svg";
export { ForwardRef as ReactComponent };